import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { emailSuggestion } from "../lib/bfu";

export const EmailHint = ({ email, onFix }) => {
  const suggestion = emailSuggestion(email);
  if (!suggestion) return null;
  return (
    <p className="text-xs font-medium text-amber-700" data-testid="email-hint">
      Nemá být e-mail spíš <b>{suggestion}</b>?{" "}
      <button type="button" className="font-semibold underline" onClick={() => onFix(suggestion)} data-testid="email-hint-fix">
        Ano, opravit
      </button>
    </p>
  );
};

export const ResendCode = ({ onResend, testId = "resend-code" }) => {
  const [left, setLeft] = useState(60);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (left <= 0) return;
    const t = setTimeout(() => setLeft((v) => v - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);
  if (left > 0)
    return (
      <p className="text-center text-xs text-slate-400" data-testid={`${testId}-countdown`}>
        Kód nedorazil? Nový budete moci poslat za {left} s.
      </p>
    );
  return (
    <button type="button" disabled={busy} data-testid={testId}
      className="flex w-full items-center justify-center gap-1.5 py-1 text-center text-sm font-semibold text-emerald-700 underline hover:text-emerald-900"
      onClick={async () => { setBusy(true); try { await onResend(); setLeft(60); } finally { setBusy(false); } }}>
      {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Poslat kód znovu
    </button>
  );
};
